import React, {Component} from "react";
import {observer} from "mobx-react";

@observer
class OrderCardProdView extends Component {
    render() {

        const { prod } = this.props;

        return (
            //배달비의 경우 prodType 이 null로 내려옴
            <span className={(prod.prodType && prod.prodType==="M") || prod.prodType === null ? "m" : "s"}>
                <span className="name">{prod.prodName}</span>
                <span className="num">{prod.saleQty}</span>
            </span>
        );
    }
}

export default OrderCardProdView;